import { render, staticRenderFns } from "./CloneSurvey.vue?vue&type=template&id=cb7138d2&"
import script from "./CloneSurvey.vue?vue&type=script&lang=js&"
export * from "./CloneSurvey.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports